// ログイン画面（外枠）。
export function renderLogin(root, { login }) {
  root.innerHTML = `
    <div class="login">
      <div class="login__card">
        <div class="login__mark">V</div>
        <div class="login__title">VEIL-Neb</div>
        <div class="login__sub">エースジャパン 統合TMS</div>
        <button class="btn btn--primary" id="login-btn" style="width:100%;padding:11px 12px;font-size:14px">Google でログイン</button>
        <p class="login__error" id="login-error"></p>
        <p class="login__sub" style="margin:14px 0 0">許可されたアカウント専用</p>
      </div>
    </div>`
  const btn = root.querySelector('#login-btn')
  const err = root.querySelector('#login-error')
  btn.addEventListener('click', async () => {
    err.textContent = ''
    btn.disabled = true
    btn.textContent = 'サインイン中…'
    try {
      await login()
    } catch (e) {
      err.textContent = e.message || 'ログインに失敗しました'
    } finally {
      btn.disabled = false
      btn.textContent = 'Google でログイン'
    }
  })
  root.removeAttribute('aria-busy')
}
